<script>
    import TextField from "../../common/text-field.vue";
    import SelectField from "../../common/select-field.vue";
    import FilterAutocomplete from "../common/table/filter-autocomplete.vue";
    import Checkbox from "../common/PrimeVue/Checkbox.vue";
    import IconTooltip from "../../common/icon-tooltip.vue";

    export default {
        name: "content-dialog-field",
        components: {IconTooltip, Checkbox, FilterAutocomplete, SelectField, TextField},
        props: {
            params: {},
            required: Boolean,
            autofocus: Boolean,
            disabled: Boolean
        },
        computed: {
            rule() {
                return {
                    required: value => !!value || Lang.langGet('This field is required'),
                }
            },
            rules() {
                if (this.required) return [this.rule.required];
            },
            checkboxClass() {
                if (this.disabled) {
                    return 'd-flex text-muted cursor-default';
                }
                return 'd-flex';
            },
            translations() {
                return {
                    name: Lang.langGet('Name'),
                    resolution: Lang.langGet('resolution'),
                    width: Lang.langGet('Width'),
                    height: Lang.langGet('Height'),
                    format: Lang.langGet('Ratio'),
                    tags: Lang.langGet('Tags'),
                    label: Lang.langGet('Resolution'),
                    useLayer: Lang.langGet('Also assign layer to template'),
                    strictModeTags: Lang.langGet('Strict mode for tags'),
                    dynamicAutoremove: Lang.langGet('Auto remove tagged elements')
                }
            },
        }
    }
</script>

<template>
    <div class="ma-2">
        <text-field v-if="params.type === 'text'"
            :disabled="disabled"
            :autofocus="autofocus"
            :label="translations[params.property]"
            :value="params.value"
            :rules="rules"
            @input="val => $emit('input', params.property, val)"
        />
        <number-field v-if="params.type === 'number'"
            :disabled="disabled"
            outlined
            dense
            :min="0"
            :max="65536"
            :label="translations[params.property]"
            :value="params.value"
            :rules="rules"
            @input="val => $emit('input', params.property, val)"
        />
        <v-select-custom v-if="params.type === 'select'"
            popup-used-in-modal
            :disabled="disabled"
            :items="params.items"
            :label="translations[params.property]"
            :value="params.value"
            @input="val => $emit('input', params.property, val)"
            hideDetails
        />
        <filter-autocomplete v-if="params.type === 'multiSelect'"
            popup-used-in-modal
            :userEnteredItemsEnabled="false"
            portalAnchorClass="popper-menu-anchor"
            :disabled="disabled"
            :items="params.items"
            :label="translations[params.property]"
            :value="params.value"
            @input="val => $emit('input', params.property, val)"
        />
        <div v-if="params.type === 'checkbox'" :class="checkboxClass">
            <Checkbox
                binary
                :disabled="disabled"
                :modelValue="params.value"
                @input="val => $emit('input', params.property, val)"
            />
            <span class="ml-3">{{translations[params.property]}}</span>
            <icon-tooltip v-if="params.hint"
                style="height: 60%"
                :hintText="params.hint"
            />
        </div>
    </div>
</template>


